export default __webpack_public_path__ + "static/media/hatchback-v3-1104x828-30fps.0c672f26.webm";